<elder-basic-pane-layout class="full">
  <elder-pane>
    <mat-tab-group class="flex" animationDuration="0" elderTabGroupRouting="propertyTab">
      @for (kind of kinds; track kind) {
        <mat-tab>
          <span *matTabLabel>
            {{ 'properties.kind.' + kind | translate }}
          </span>
          <app-property-browser class="flex" [kinds]="[kind]"> </app-property-browser>
        </mat-tab>
      }
    </mat-tab-group>
  </elder-pane>
</elder-basic-pane-layout>
